export const paths = {
  home: '/',
  checkout: '/checkout',
  contact: '/contact',
  pricing: '/pricing',
  auth: {
    custom: {
      signIn: '/auth/custom/sign-in',
      signUp: '/auth/custom/sign-up',
      resetPassword: '/auth/custom/reset-password',
    },
    auth0: {
      callback: '/auth/auth0/callback',
      signIn: '/auth/auth0/sign-in',
      signUp: '/auth/auth0/sign-up',
      signOut: '/auth/auth0/sign-out',
      profile: '/auth/auth0/profile',
    },
    cognito: {
      signIn: '/auth/cognito/sign-in',
      signUp: '/auth/cognito/sign-up',
      signUpConfirm: '/auth/cognito/sign-up-confirm',
      newPasswordRequired: '/auth/cognito/new-password-required',
      resetPassword: '/auth/cognito/reset-password',
      updatePassword: '/auth/cognito/update-password',
    },
    firebase: {
      signIn: '/auth/firebase/sign-in',
      signUp: '/auth/firebase/sign-up',
      resetPassword: '/auth/firebase/reset-password',
      recoveryLinkSent: '/auth/firebase/recovery-link-sent',
      updatePassword: '/auth/firebase/update-password',
    },
    supabase: {
      callback: '/auth/supabase/callback',
      signIn: '/auth/supabase/sign-in',
      signUp: '/auth/supabase/sign-up',
      signUpConfirm: '/auth/supabase/sign-up-confirm',
      resetPassword: '/auth/supabase/reset-password',
      recoveryLinkSent: '/auth/supabase/recovery-link-sent',
      updatePassword: '/auth/supabase/update-password',
    },
    samples: {
      signIn: { centered: '/auth/samples/sign-in/centered', split: '/auth/samples/sign-in/split' },
      signUp: { centered: '/auth/samples/sign-up/centered', split: '/auth/samples/sign-up/split' },
      updatePassword: {
        centered: '/auth/samples/update-password/centered',
        split: '/auth/samples/update-password/split',
      },
      resetPassword: { centered: '/auth/samples/reset-password/centered', split: '/auth/samples/reset-password/split' },
      verifyCode: { centered: '/auth/samples/verify-code/centered', split: '/auth/samples/verify-code/split' },
    },
  },
  dashboard: {
    overview: '/dashboard',
    taxShield: {
      overview: '/dashboard/tax-shield/overview',
      // messages: {
      //   list: (label: string) => `/dashboard/tax-shield/messages/${label}`,
      //   details: (label: string, emailId: string) => `/dashboard/tax-shield/messages/${label}/${emailId}`,
      // },
      documents: '/dashboard/tax-shield/documents',
      reports: '/dashboard/tax-shield/reports',
      enrollment: '/dashboard/tax-shield/enrollment'
    },
    taxPreparation: '/tax-preparation-service',
    taxRelief: '/',
    noticeAnalyzer: '/notice-analyzer',
    protectionPlanEnrollment: '/dashboard/protection-plan-enrollment',
    graduatedResEnrollment: '/dashboard/graduated-res-enrolment',
    uploadTaxReturn: '/dashboard/upload-tax-return'
  },
  settings: {
    upgrade: '/settings/upgrade-plan',
    myaccount: {
      profile: '/settings/profile',
      security: '/settings/security',
      paymentMethods: '/settings/billing',
      changePlan: '/settings/billing/change-plan',
      notifications: '/settings/notifications',
      changePlanEnrolment: '/change-plan/enrolment'
    },
    getHelp: '/account-settings-contactus',
    clientPortal: '/',
    signOut: '/sign-out',
  },
  partner: {
    dashboard: {
      overview: '/partner-dashboard',
      myReferrals: '/partner-referrals',
      myJobs: {
        newJobs: '/',
        acceptedJobs: '/',
        declinedJobs: '/'
      },
      myPartners: '/',
    },
    settings: {
      myaccount: {
        settings: 'partner/settings/profile',
        profile: 'partner-profile-info',
        licensesInsurance: '/settings/licenses-insurance',
        passwordReset: '/settings/security',
        notifications: 'partner/settings/notifications',
        sharingQRcode: '/settings/qrcode-sharing',
      },
      getHelp: '/',
      signOut: '/sign-out',
    },
  },
  pdf: { invoice: (invoiceId: string) => `/pdf/invoices/${invoiceId}` },
  components: {
    index: '/components',
    buttons: '/components/buttons',
    charts: '/components/charts',
    colors: '/components/colors',
    detailLists: '/components/detail-lists',
    forms: '/components/forms',
    gridLists: '/components/grid-lists',
    groupedLists: '/components/grouped-lists',
    inputs: '/components/inputs',
    modals: '/components/modals',
    quickStats: '/components/quick-stats',
    tables: '/components/tables',
    typography: '/components/typography',
  },
  notAuthorized: '/errors/not-authorized',
  notFound: '/errors/not-found',
  internalServerError: '/errors/internal-server-error',
  docs: 'https://material-kit-pro-react-docs.devias.io',
  purchase: 'https://mui.com/store/items/devias-kit-pro',
} as const;
